module.exports = __webpack_public_path__ + "static/media/NewTaskIcon.6a56be86.svg";